module.exports = __webpack_public_path__ + "img/icon-angle-top.03323026.svg";